import { FiCheck } from "react-icons/fi";

export const SponsorshipPackageTableDesktop = () => {
  return (
    <div className="w-10/12 overflow-hidden -mt-8 flex flex-row">
      <div className="h-max w-1/2">
        <div className="flex flex-col">
          <p className="h-20"></p>
          <p className="h-20 border-2 border-black border-r-0 border-b-0  border-opacity-0 px-6 flex items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Acknowledged and thanked at internal events
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 border-b-0 px-6 flex items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Logo on website
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 border-b-0 px-6 flex items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Logo on jersey
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 border-b-0 flex px-6 items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Acknowledgements on Social Media
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 border-b-0 flex px-6 items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Company logo on posters
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 border-b-0 flex px-6 items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Company acknowledgement in Newsletters
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 border-b-0 flex px-6 items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Inclusion in outreach events
          </p>
          <p className="h-20 border-2 border-black  border-opacity-0 border-r-0 flex px-6 items-center plus-jakarta-sans-body text-black text-opacity-80 text-md">
            Distribution of company advertisments to team
          </p>
        </div>
      </div>
      <div className="h-max w-48">
        <div className="flex flex-col justify-center items-center">
          <p className="h-20 flex justify-center items-end pb-2 plus-jakarta-sans-button text-xl">
            Innovation Partner
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 border-b-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 border-r-0 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
        </div>
      </div>
      <div className="h-max w-48">
        <div className="flex flex-col justify-center items-center">
          <p className="h-20 flex justify-center items-end pb-2 plus-jakarta-sans-button text-xl">
            Visionary Sponsor
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex border-r-0 border-b-0 items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 border-r-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 border-r-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 border-r-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 border-r-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center justify-center border-r-0 plus-jakarta-sans-button text-red-700 text-md"></p>
        </div>
      </div>
      <div className="h-max w-48">
        <div className="flex flex-col justify-center items-center">
          <p className="h-20 flex justify-center items-end pb-2 plus-jakarta-sans-button text-xl">
            Community Sponsor
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex border-r-0 border-b-0 items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-r-0 border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex  items-center border-r-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
        </div>
      </div>
      <div className="h-max w-48">
        <div className="flex flex-col justify-center items-center">
          <p className="h-20 flex justify-center items-end pb-2 plus-jakarta-sans-button text-xl">
            Supporting Sponsor
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex  border-b-0 items-center justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md">
            <FiCheck strokeWidth={4} />
          </p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center border-b-0 justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
          <p className="h-20 w-full border-2 border-black  border-opacity-5 flex items-center justify-center plus-jakarta-sans-button text-red-700 text-md"></p>
        </div>
      </div>
    </div>
  );
};
